<template lang="pug">
  section
    .field.is-pulled-right
      .control
        button(class="button is-danger" @click="isSearchModalFormActive = true")
          b-icon(pack="fas" custom-class="fa-sm fa-search")
          span
            | 検索
        b-modal(:active.sync="isSearchModalFormActive" has-modal-card)
          search-modal-form(:formProps.sync="formProps" @on-search="onSearch")

    b-table(
      :data="manipulated_order_items"
      :loading="loading"
      narrowed
      hoverable
      striped
      icon-pack="fa"
      paginated
      backend-pagination
      pagination-size="is-small"
      pagination-position="both"
      :total="total"
      :current-page="page"
      :per-page="perPage"
      @page-change="onPageChange"
      class="pointable"
    )
      template(slot-scope="props")
        b-table-column(field="delivered_all" label="全納" width="30")
          b-checkbox(v-model="props.row.delivered_all" data-vv-as="全納" disabled)
        b-table-column(field="book_name" label="書籍名" width="200")
          | {{ props.row.book_name }}
        b-table-column(field="isbn" label="ISBN" width="110")
          | {{ props.row.isbn }}
        b-table-column(field="shop_code" label="書店名" width="150")
          | {{ props.row.book_shop_name }}
        b-table-column(field="order_number" label="受注数" width="40")
          | {{ props.row.accepting_order_item_order_number }}
        b-table-column(field="delivered_number" label="配本数" width="40")
          | {{ props.row.order_number }}
        b-table-column(field="order_route_name" label="受注経路" width="60")
          | {{ props.row.order_route_name }}
        b-table-column(field="deliver_type_id" label="出荷属性" width="60")
          | {{ props.row.deliver_type_name }}
        b-table-column(field="accepting_order_sid" label="受注管理ID" width="60")
          | {{ props.row.accepting_order_sid }}
        b-table-column(field="manipulated_order_sid" label="配本管理ID" width="60")
          | {{ props.row.manipulated_order_sid }}
        b-table-column(field="bibo" label="備忘" width="150")
          | {{ props.row.bibo }}
        b-table-column(field="kyakutyu_memo" label="客注" width="150")
          | {{ props.row.kyakutyu_memo }}
        b-table-column(field="user_name" label="登録者" width="60")
          | {{ props.row.user_name }}
</template>

<script>
  import SearchModalForm from './manipulated_order_items/search_modal_form'
  import ManipulatedOrderItem from 'models/manipulated_order_item'

  export default {
    name: 'manipulated-order-items-table',
    components: {
      SearchModalForm
    },
    data() {
      return {
        manipulated_order_items: [new ManipulatedOrderItem],
        isSearchModalFormActive: false,
        formProps: {},
        total: 0,
        page: 1,
        perPage: 25,
        loading: false
      }
    },
    methods: {
      makeToast(message) {
        this.$toast.open({
          message: message,
          type: 'is-danger',
          position: 'is-bottom'
        })
      },
      onSearch() {
        this.onPageChange(1)
      },
      onPageChange(page) {
        this.page = page
        this.loadAsyncData()
      },
      loadAsyncData() {
        this.loading = true

        const params = [
          `page=${this.page}`,
          `per_page=${this.perPage}`,
          Object.keys(this.formProps).map((key) => {
            return `q[${key}]=${this.formProps[key]}`
          }).join('&')
        ].join('&')
        const url = `/api/v1/manipulated_order_items.json?${params}`

        this.$http.get(url).then(({data}) => {
          this.manipulated_order_items = []
          const manipulated_order_items = data.manipulated_order_items
          if(manipulated_order_items.length == 0) {
            this.makeToast('データが見つかりませんでした。')
            this.total = 0
            this.loading = false
            return
          }

          manipulated_order_items.forEach(item => {
            this.manipulated_order_items.push(new ManipulatedOrderItem(item))
          })
          this.total = data.total
          this.loading = false
        })
        .catch(error => {
          this.manipulated_order_items = []
          this.total = 0
          this.loading = false
          this.makeToast('検索に失敗しました。')
          throw error
        })
      }
    }
  }
</script>
